import React from 'react';

import ResetPasswordForm from '@/components/resetPassword/ResetPasswordForm';

const ResetPassword = () => {
  return (
    <div className="h-[calc(100vh-84px)] flex items-center justify-center">
      <ResetPasswordForm />
    </div>
  );
};

export default ResetPassword;
